import React from "react";
import PropTypes from "prop-types";
import { classes, useVoltState } from "@mqd/volt-toolbox/src";
import { Icon } from "@mqd/volt-core/src";
import { LeftNavLink } from "./left-nav-link.js";
import { isMenuActive } from "./is-active.js";
import css from "./left-nav.module.css";
const LINK_HEIGHT = 40;
export function LeftNavMenu({ children, activePath, persist, title }) {
  const leftNav = useVoltState((state) => state.leftNav);
  const [isActive, setIsActive] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(
    () => persist ? leftNav.menus[title] : false
  );
  const style = {
    height: isOpen ? `${children.length * LINK_HEIGHT}px` : "0"
  };
  const handleToggle = () => setIsOpen(!isOpen);
  React.useEffect(() => {
    leftNav.menus[title] = isOpen;
  }, [isOpen]);
  React.useEffect(() => {
    if (!activePath)
      return;
    const menuIsActive = isMenuActive(children, activePath);
    setIsActive(menuIsActive);
    if (menuIsActive)
      setIsOpen(true);
  }, [activePath]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: classes(css.leftNavParent, {
        [css["--active"]]: isActive,
        [css["--open"]]: isOpen,
        [css["--active-collapsed"]]: isActive && !isOpen
      }),
      onClick: handleToggle,
      "data-testid": `left-nav-link_${title}`
    },
    title,
    /* @__PURE__ */ React.createElement(Icon, { name: "chevron-down", className: css.leftNavLinkCaret })
  ), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: classes(css.leftNavNestedLinks, isOpen && css["--expanded"]),
      style
    },
    children.map((child) => {
      const { title: title2 } = child;
      return /* @__PURE__ */ React.createElement(LeftNavLink, { key: title2, activePath, ...child }, title2);
    })
  ));
}
LeftNavMenu.propTypes = {
  activePath: PropTypes.string,
  children: PropTypes.any,
  persist: PropTypes.bool,
  title: PropTypes.string
};
LeftNavMenu.defaultProps = {};
